"use client"

import { Box, Text, Flex } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { LuFacebook, LuInstagram, LuTwitter, LuYoutube, LuSearch, LuMenu, LuTimer } from "react-icons/lu"
//import moment from 'moment';
//import 'moment/locale/pt-br';
//moment.locale('pt-br');
import moment from 'moment-timezone';
import 'moment/locale/pt-br';
moment.locale('pt-br');

export function headerDated(data = new Date(), hasWeekDate = false) {
  const m = moment(data).tz('America/Sao_Paulo');
  const diaSemana = m.format('dddd');
  const dia = m.date();
  const mes = m.format('MMMM');
  const ano = m.year();

  const weekDate = hasWeekDate === true ? `${diaSemana.charAt(0).toUpperCase() + diaSemana.slice(1)}, dia ` : '';

  return `${weekDate}${dia} de ${mes.charAt(0).toUpperCase() + mes.slice(1)} de ${ano}`;
}

export function agoDated(data = new Date()) {
  return moment(data).tz('America/Sao_Paulo').fromNow();
}


export function luIcon(icon, size = 'sm') {
  const iconsMap = {
    LuFacebook,
    LuInstagram,
    LuTwitter,
    LuYoutube,
    LuSearch,
    LuMenu
  };

  const LuIcon = iconsMap[icon];

  return (
    <Box as={LuIcon} boxSize={size} />
  )
}

export function addressInfo(joinType = ', ') {
  const localAddress = [
    'Rua Nestor Guimarães, 77',
    '9ª andar, Sala 905',
    'Vila Estrela, Ponta Grossa - PR',
    'CEP: 84040-130'
  ]

  return localAddress.join(joinType)
}

export function theContent(content) {
  const [html, setHtml] = useState('');

  useEffect(() => {
    setHtml(content);
  }, []);

  return (
    <Box suppressHydrationWarning={true} dangerouslySetInnerHTML={{ __html: html }}></Box>
  )
}

export function preContent(subtitle, content, size = 200) {
  if(subtitle) {
    return subtitle;
  }

  content = content.slice(0, size);
  content = `${content} [...]`;

  return theContent(content);
}

export function theCat(cats, key = false) {
  if(!cats || cats.length === 0) return 'Sem Categoria';
  const cat = cats[0];
  if(key === false) return cat[0];
  return cat[key];
}
